// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Nc545","menu":"classes_menu__wy5oy","open":"classes_open__qATGP","menu-item":"classes_menu-item__lqqiy","icon":"classes_icon__Zfsk7"};